<template>
    <v-container fluid>
    <v-row>
        <v-col cols="12" sm="4" md="4">
            <v-text-field
                v-model="item.id"
                :label="$t('order.id')"
                type="number"
            />
        </v-col>

        <v-col cols="12" sm="4" md="4">
            <v-text-field
                v-model="item.ref"
                :label="$t('order.ref')"
                type="text"
            />
        </v-col>

        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.type"
                    :items="typeSelectItems"
                    :no-data-text="$t('global.no_result')"
                    :placeholder="$t('global.no_select')"
                    clearable
                    multiple
                    :label="$t('order.type')"
                    item-text="name"
                    item-value="@id"
                />
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.customer"
                    :items="customerSelectItems"
                    :no-data-text="$t('global.no_result')"
                    :placeholder="$t('global.no_select')"
                    clearable
                    multiple
                    :label="$t('customer.customer')"
                    item-text="name"

                />
        </v-col>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.commercial"
                    :items="enabledCommercialSelectItems"
                    :no-data-text="$t('global.no_result')"
                    :placeholder="$t('global.no_select')"
                    clearable
                    multiple
                    :label="$t('order.claimant')"
                    item-text="login"
                    item-value="@id"
                />
        </v-col>

        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.operator"
                :items="enabledOperatorSelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                multiple
                :label="$t('order.operator')"
                item-text="login"
                item-value="@id"
            />
        </v-col>
                
    </v-row>

    <v-row>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.state"
                    :items="orderstateSelectItems"
                    :no-data-text="$t('global.no_result')"
                    :placeholder="$t('global.no_select')"
                    clearable
                    multiple
                    :label="$t('order.state')"
                    item-text="name"
                    item-value="@id"
                />
        </v-col>

        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.priority"
                :items="prioritySelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('priority.priority')"
                item-text="name"
                item-value="@id"
            />
        </v-col>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.material"
                :items="materialSelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                multiple
                :label="$t('material.material')"
                item-text="name"
                item-value="@id"
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.sector"
                :items="sectorSelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                multiple
                :label="$t('sector.sector')"
                item-text="name"
                item-value="@id"
            />
        </v-col>

        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.verticale"
                :items="verticaleSelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                multiple
                :label="$t('verticale.verticale')"
                item-text="name"
                item-value="@id"
            />
        </v-col>
        <v-col cols="12" sm="4" md="4">
            <v-combobox
                v-model="item.tags"
                :items="tagSelectItems"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                multiple
                :label="$t('order.tag')"
                item-text="name"
                item-value="@id"
                color="primary"
                chips
            >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        color="primary"
                        :input-value="selected"
                        label
                    >
                        <span class="pr-2">
                            {{ item.name }}
                        </span>
                    </v-chip>
                </template>
            </v-combobox>
    </v-col>
        
    </v-row>

    <v-row>
        
                
    </v-row>
        
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <h3>{{ $t('order.delivery_interne') }}</h3>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <h3>{{ $t('order.delivery') }}</h3>
            </v-col>
        </v-row>

            <v-row>
                <v-col cols="12" sm="3" md="3">
                    <InputDate
                        v-model="item.delivery_after"
                        :label="$t('global.datestart')"
                    />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <InputDate
                        v-model="item.delivery_before"
                        :label="$t('global.dateend')"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <InputDate
                        v-model="item.deliveryObjectif_after"
                        :label="$t('global.datestart')"
                    />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <InputDate
                        v-model="item.deliveryObjectif_before"
                        :label="$t('global.dateend')"
                    />
                </v-col>
            </v-row>

        <v-row>
            <v-col cols="12" sm="6" md="6">
                <h3>{{ $t('global.createdat') }}</h3>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <h3>{{ $t('global.updatedat') }}</h3>
            </v-col>
            
        </v-row>

        <v-row>
            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.created_after"
                    :label="$t('global.datestart')"
                />
            </v-col>

            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.created_before"
                    :label="$t('global.dateend')"
                />
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.updated_after"
                    :label="$t('global.datestart')"
                />
            </v-col>

            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.updated_before"
                    :label="$t('global.dateend')"
                />
            </v-col>
        </v-row>

        <v-row>
            <h3>{{ $t('global.closeddat') }}</h3>
        </v-row>

        <v-row>
            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.dateCloture_after"
                    :label="$t('global.datestart')"
                />
            </v-col>

            <v-col cols="12" sm="3" md="3">
                <InputDate
                    v-model="item.dateCloture_before"
                    :label="$t('global.dateend')"
                />
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default {
    name: 'OrderFilter',
    components: {
        InputDate,
    },
    props: {
        values: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        };
    },
    mounted() {
        this.customerGetSelectItems();
        this.typeGetSelectItems();
        this.orderstateGetSelectItems();
        this.priorityGetSelectItems();
        this.commercialGetSelectItems();
        this.materialGetSelectItems();
        this.operatorGetSelectItems();
        this.sectorGetSelectItems();
        this.tagGetSelectItems();
        this.verticaleGetSelectItems();
    },

    computed: {
        ...mapFields('customer', {
            customerSelectItems: 'selectItems',
        }),
        ...mapFields('material', {
            materialSelectItems: 'selectItems',
        }),
        ...mapFields('ordertype', {
            typeSelectItems: 'selectItems',
        }),
        ...mapFields('orderstate', {
            orderstateSelectItems: 'selectItems',
        }),
        ...mapFields('priority', {
            prioritySelectItems: 'selectItems',
        }),
        ...mapFields('sector', {
            sectorSelectItems: 'selectItems',
        }),
        ...mapFields('user', {
            commercialSelectItems: 'selectItems',
        }),
        ...mapFields('user', {
            operatorSelectItems: 'selectItems',
        }),
        ...mapFields('tag', {
        tagSelectItems: 'selectItems',
        }),
        ...mapFields('verticale', {
            verticaleSelectItems: 'selectItems',
        }),
        // eslint-disable-next-line
        item() {
            return this.initialValues || this.values;
        },
        enabledCommercialSelectItems() {
            if (this.commercialSelectItems) {
                return this.commercialSelectItems.filter(item => item.enabled && !item.supervision);
            }
            return [];
        },
        enabledOperatorSelectItems() {
            if (this.operatorSelectItems) {
                return this.operatorSelectItems.filter(item => item.enabled && !item.supervision);
            }
            return [];
        },
    },
    methods: {
        ...mapActions({
            customerGetSelectItems: 'customer/fetchSelectItems',
            typeGetSelectItems: 'ordertype/fetchSelectItems',
            materialGetSelectItems: 'material/fetchSelectItems',
            orderstateGetSelectItems: 'orderstate/fetchSelectItems',
            priorityGetSelectItems: 'priority/fetchSelectItems',
            commercialGetSelectItems: 'user/fetchSelectItems',
            operatorGetSelectItems: 'user/fetchSelectItems',
            sectorGetSelectItems: 'sector/fetchSelectItems',
            tagGetSelectItems: 'tag/fetchSelectItems',
            verticaleGetSelectItems: 'verticale/fetchSelectItems',

        }),
    }
};
</script>
